import React from "react"
import { components, elements } from "../DefaultMarkdown"
import { getCompiler } from "utils/MarkdownCompile"
import PropTypes from "prop-types"
import { TextLink } from "../atoms/links/TextLink"
import styled from "styled-components"
/* eslint-disable */
const libraryElements = {
  ...elements,
  p: ({ children }) => <p className="lh-copy gotham black-80 mt0 mb3">{children}</p>,
  a: ({ href, children, title }) => (
    <TextLink target="_blank" title={title} to={href}>
      {children}
    </TextLink>
  ),
  h4: ({ children }) => <h4 className="b gotham black-80 mb2 mt4 f6">{children}</h4>,
  h3: ({ children }) => <h3 className="b gotham black-80 mb2 mt4 f5">{children}</h3>,
  h2: ({ children }) => <h2 className="b gotham black-80 mb2 mt4 f4">{children}</h2>,
  table: ({ children }) => (
    <div className="overflow-x-auto">
      <table className="f5 v-top w-100 t--fixed collapse pv2 ph3 ba --moon-gray bg-black-05">{children}</table>
    </div>
  ),
  li: styled.li.attrs({ className: "gotham lh-copy" })`
    margin: 8px 0 8px 0;
    *:first-child {
      display: inline;
    }
  `
}

const md = getCompiler(libraryElements, components)

const LibraryMarkdown = ({ additionalClasses, source }) => (
  <div className={`m0-first-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

LibraryMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string
}

export default LibraryMarkdown
